module.exports = __webpack_public_path__ + "img/IMG_8155_FoamcoreMatted.e3f88536.jpg";